import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class BoxContact extends Component {
  render() {
    return (
      <div className="box box-contact">
        <div className="contact-infos">
          <div className="row-contact">
            <strong>{this.props.contact.contact_name}</strong>
            <span>{this.props.contact.email}</span>
            <span>{this.props.contact.phone_number}</span>
          </div>
          <div className="row-contact">
            <strong>Endereço</strong>
            <span>
              {this.props.contact.address}, {this.props.contact.number} - {this.props.contact.district},
            </span>{' '}
            <span>
              {this.props.contact.city}, {this.props.contact.state} {this.props.contact.cep}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect((state) => ({
    contact: state.purchase.contact,
  }))(BoxContact)
);



// WEBPACK FOOTER //
// ./src/components/purchase/purchase_description/BoxContact.jsx